/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Email1Inputs */

const en_formfields_email1 = /** @type {(inputs: Formfields_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Formfields_Email1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_email1 = /** @type {((inputs?: Formfields_Email1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Email1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_email1(inputs)
});
export { formfields_email1 as "formFields_email" }